import { createContext, useContext } from 'react';

const TableSortContext = createContext(null);

export const TableSortProvider = ({ children, value }) => {
  return (
    <TableSortContext.Provider value={value}>
      {children}
    </TableSortContext.Provider>
  );
};

export const useTableSort = () => useContext(TableSortContext);
